import { useQuery } from '@tanstack/react-query';
import { clientWithAuth } from 'dashboard409a/services/base';
import {
  FulfillmentModelLeaderboardEntry,
  FulfillmentModelLeaderboardFilters,
  FulfillmentModelLeaderboardResponse,
} from 'dashboard409a/services/fulfillmentModelLeaderboard.types';

export const FulfillmentModelLeaderboardQueryKeys = {
  LEADERBOARD: 'fulfillment-model-leaderboard',
} as const;

export const fetchFulfillmentModelLeaderboard = async (
  filters: FulfillmentModelLeaderboardFilters = {},
  signal?: AbortSignal
): Promise<FulfillmentModelLeaderboardResponse> => {
  const response = await clientWithAuth.get<FulfillmentModelLeaderboardResponse>(
    '/api/dashboard/user/models/leaderboard/',
    {
      signal,
      params: {
        from_date: filters.fromDate,
        to_date: filters.toDate,
      },
    }
  );
  return response.data;
};

export const getLeaderboardDisplayName = (entry: FulfillmentModelLeaderboardEntry): string => {
  const name = [entry.first_name, entry.last_name].filter(Boolean).join(' ').trim();
  return name || entry.email;
};

export const formatLeaderboardDateParam = (value: Date | null): string | undefined => {
  if (!value || Number.isNaN(value.getTime())) {
    return undefined;
  }
  return value.toISOString().split('T')[0];
};

export const useFulfillmentModelLeaderboard = (
  enabled: boolean,
  filters: FulfillmentModelLeaderboardFilters = {}
) =>
  useQuery({
    queryKey: [
      FulfillmentModelLeaderboardQueryKeys.LEADERBOARD,
      filters.fromDate ?? null,
      filters.toDate ?? null,
    ],
    queryFn: ({ signal }) => fetchFulfillmentModelLeaderboard(filters, signal),
    enabled,
    staleTime: 60 * 1000,
  });
